import * as React from 'react';
import { HeaderFilterTable, Icon } from '@/components/common';
import { Options } from '@/components/ui/combobox';
import Icons from '@/const/icons';
import { GET_CLEANUP_WIZARD_REASON_FILTER } from '@/api';
import { useQuery } from '@tanstack/react-query';
import { useFilters } from '@/hooks';
import { cleanupWizardService } from '@/api/cleanupWizard';

export const ReasonFilter = () => {
	const FILTER_KEY = 'reason';
	const { setParamFilter, hasFilter } = useFilters();
	const [data, setData] = React.useState<Options[]>([]);

	const { data: reasonsFilterList } = useQuery({
		queryKey: [GET_CLEANUP_WIZARD_REASON_FILTER],
		queryFn: () => cleanupWizardService.getReasonFilter(),
	});

	React.useEffect(() => {
		if (reasonsFilterList) {
			const auxList: Options[] = [];
			reasonsFilterList.data.map((item) =>
				auxList.push({
					label: item,
					value: item,
					icon: (
						<Icon
							src={Icons.infoCircle}
							width={18}
							height={18}
							className="text-primary"
						/>
					),
				})
			);
			setData(auxList);
		}
	}, [reasonsFilterList]);

	const handleSelectFilters = (value?: string) => {
		setParamFilter(FILTER_KEY, value);
	};

	const handleClearAll = () => {
		setParamFilter(FILTER_KEY, '');
	};

	return (
		<HeaderFilterTable
			title="Reason"
			searchTitle="Filter by reason"
			filterOptions={data}
			classNamePopoverContent="lg:!w-[343px] lg:!h-[328px]"
			handleClearAll={handleClearAll}
			handleSelectFilters={handleSelectFilters}
			hasFilter={hasFilter(FILTER_KEY)}
		/>
	);
};
